import { generatePath } from "react-router-dom";
export const getPath = (path) => {
    const pushPath = (params = {}) => generatePath(`${process.env.APP_PATH || ""}${path}`, params);
    return { path, pushPath };
};
